import { z } from 'zod';
export const mswAssessmentValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        numberOfVisits: z.string().optional().nullable(),
        visits: z.array(z.string()).optional(),
        physicalStatus: z.string().optional().nullable(),
        mentalStatus: z.string().optional(),
        emotionalStatus: z.string().optional(),
        funcStatus: z.string().optional(),
        healthStatus: z.string().optional(),
        financialStatus: z.string().optional(),
        vulnerable: z.string().optional(),
        appropriateness: z.string().optional(),
        livingEnv: z.string().optional(),
        econIssues: z.string().optional(),
        envOther: z.string().optional(),
        patientAssessmentComments: z.string().optional(),
        patientAssessment: z.boolean().optional(),
        communityLinkageComments: z.string().optional(),
        communityLinkage: z.boolean().optional(),
        counselingServicesComments: z.string().optional(),
        counselingServices: z.boolean().optional(),
        medicalSocialServicesComments: z.string().optional(),
        medicalSocialServices: z.boolean().optional(),
        desiredOutcome: z.string().optional(),
        mswGoal: z.string().optional(),
        followUpPlan: z.string().optional(),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
